import { render } from "./InconformidadesPage.vue?vue&type=template&id=482096a4"
import script from "./InconformidadesPage.vue?vue&type=script&lang=js"
export * from "./InconformidadesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__